import React, { useState } from 'react';
import Button from '../Form/Button';
import FilterMoreOption from './FilterMoreOption';

interface IProps {
  setSelectedOrder: (arg: string | null) => void;
  iconPosition?: 'left' | 'right';
  label: string;
  icon?: React.ReactNode;
  title?: string;
  handleTableSearch: () => void;
}

const FilterDropdown: React.FC<IProps> = ({
  iconPosition,
  label,
  icon,
  handleTableSearch
}) => {
  const [isSortDropdownVisible, setIsSortDropdownVisible] = useState(false);

  return (
    <div className="relative z-10" style={{ zIndex: 2 }}>
      <Button
        variant="secondary"
        size="sm"
        label={label}
        icon={icon}
        iconPosition={iconPosition}
        type="button"
        onClick={() => {
          setIsSortDropdownVisible(true);
        }}
        className="h-[35px] rounded-r border-[#9F9F9F] bg-[#F5F8FA] font-normal text-[#737373]"
      />
      {isSortDropdownVisible && (
        <FilterMoreOption
          onCancel={() => setIsSortDropdownVisible(false)}
          applyFilter={handleTableSearch}
        />
      )}
    </div>
  );
};

export default FilterDropdown;
